// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  background-color: #ffffff;\n}\nhtml,\nbody,\n.v-application,\n.v-application--wrap {\n  min-height: 100vh;\n  min-height: -webkit-fill-available !important;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}", ""]);
// Exports
module.exports = exports;
